import { ChangeEvent, useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from '../step1/OnboardingSequence';
import InputBar from '../InputBar';
// import BPInput from '../../BionicUI/input/BPInput';
// import { PostUserProfileRequest } from 'core/models/users/profile/post-user-profile.model';
// import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
// import { useAuth } from 'context/auth.context';
// import { usePrivy } from '@privy-io/react-auth';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';
import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';
import BPContainer from 'components/BionicUI/container/BPContainer';
import BPButton from 'components/BionicUI/button/BPButton';
import BPToast from 'components/BionicUI/toast/BPToast';
import useNotifyStore from 'stores/notifyStore';

const WhitePaper = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const [pdfFile, setPdfFile] = useState<File | null>(null);
  const { nextStep, setProgressStep, setProjectInfo } =
    useOnboardingProjectStore();
  const { setCurrentToast } = useNotifyStore();
  const MAX_FILE_SIZE_BYTES = 3 * 1024 * 1024; // 3 MB

  async function handleSubmit() {
    if (!pdfFile) return;
    setProjectInfo('whitePaper', pdfFile);
    nextStep();
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    if (file.type !== 'application/pdf') {
      setCurrentToast(
        <BPToast
          message="Invalid file type"
          description="Please upload a valid PDF file"
          variant="error"
        />
      );
      setPdfFile(null);
      e.target.value = '';
      return;
    }

    // Validate file size (max 3 MB)
    if (file.size > MAX_FILE_SIZE_BYTES) {
      setCurrentToast(
        <BPToast
          message="File too large"
          description="Maximum allowed size is 3 MB"
          variant="error"
        />
      );
      setPdfFile(null);
      e.target.value = '';
      return;
    }

    setPdfFile(file);
  };

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'If you have a white paper or a deck, please upload it below.',
            sound: 'projectStep/if-you-have-white-paper-or-deck.mp3',
          }}
          onAnimComplete={() => setShowInputBar(true)}
        />
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(1)}>
          <BPContainer gridClass={true}>
            <input
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              className="z-[1] text-white w-full font-medium"
            />
            <BPButton
              onClick={handleSubmit}
              disabled={pdfFile === null}
              state="primary"
            >
              Submit
            </BPButton>
          </BPContainer>
          {/* <BPInput
            state="default"
            type="text"
            placeholder="Enter project white paper"
            button={{
              state: 'primary',
              onClick: (e, inputText) => handleSubmit(inputText),
              title: 'Submit',
            }}
            validate={(text) => text.length > 3}
          /> */}
          <BPLinkButton onClick={nextStep}>Skip</BPLinkButton>
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default WhitePaper;
